import React from 'react';
import { colors } from '@alixpartners/ui-components';
import { isUndefined } from 'lodash';
import { ReactComponent as TotalBaselineSpend } from '../assets/svg/total-baseline-spend.svg';
import { ReactComponent as TotalSpendOwners } from '../assets/svg/total-spend-owners.svg';
import { ReactComponent as UniqueSuppliers } from '../assets/svg/unique-supplier-count.svg';
import { ReactComponent as TotalSuppliers } from '../assets/svg/total-supplier-records.svg';
import { ReactComponent as ResponseReceived } from '../assets/svg/responses-received.svg';
import { ReactComponent as BaselineActioned } from '../assets/svg/baseline-actioned.svg';
import { ReactComponent as PreliminarySavings } from '../assets/svg/preliminary-savings.svg';
import { ReactComponent as ResponsesPercent } from '../assets/svg/responses-received-percent.svg';
import { ReactComponent as BaselinePercent } from '../assets/svg/baseline-actioned-percent.svg';
import { ReactComponent as FinalSignedSavings } from '../assets/svg/final-signed-savings.svg';
import { ReactComponent as FinalSignedPercent } from '../assets/svg/final-signed-percent.svg';
import { ReactComponent as SavingsPending } from '../assets/svg/savings-pending.svg';
import { ReactComponent as UnclaimedBaselineSpend } from '../assets/svg/unclaimed-baseline-spend.svg';
import { ReactComponent as ContinueToUse } from '../assets/svg/continue-to-use.svg';
import { ReactComponent as Consolidate } from '../assets/svg/consolidate.svg';
import { ReactComponent as Eliminate } from '../assets/svg/eliminate.svg';
import { ReactComponent as ReduceDemand } from '../assets/svg/reduce-demand.svg';
import { ReactComponent as TotalLostSavings } from '../assets/svg/total-lost-savings.svg';
import { ReactComponent as TotalLostRecords } from '../assets/svg/total-lost-records.svg';
import { percentFormatter } from '../CategoryManagement/Dashboard/ChartsList/chartUtils';
import { spendFormatter } from './number';

//To be replaced by api
export const BASELINE_SUMMARY_DATA = [
	{
		key: 0,
		cardTitle: 'Total Baseline Spend',
		value: '$5.9M',
		isLoading: false,
		isCurrency: true,
		icon: <TotalBaselineSpend width={25} height={25} />,
		step: 'baseline-kpi-step-1',
	},
	{
		key: 1,
		cardTitle: 'Total Spend Owners',
		value: '12',
		isLoading: false,
		isCurrency: false,
		icon: <TotalSpendOwners width={25} height={25} />,
		step: 'baseline-kpi-step-2',
	},
	{
		key: 2,
		cardTitle: 'Unique Supplier Count',
		value: '204',
		isLoading: false,
		isCurrency: false,
		icon: <UniqueSuppliers width={25} height={25} />,
		step: 'baseline-kpi-step-3',
	},
	{
		key: 3,
		cardTitle: 'Total Supplier Records',
		value: '388',
		isLoading: false,
		isCurrency: false,
		icon: <TotalSuppliers width={25} height={25} />,
		step: 'baseline-kpi-step-4',
	},
];
export const PREWORKSHOP_BASELINE_SUMMARY_DATA = [
	{
		key: 0,
		cardTitle: 'Total Baseline Spend',
		value: '$5.9M',
		isLoading: false,
		icon: <TotalBaselineSpend width={25} height={25} />,
		isCurrency: true,
	},
	{
		key: 1,
		cardTitle: 'Baseline Spend Actioned',
		value: '$5.8M/98%',
		isLoading: false,
		icon: <BaselineActioned width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 2,
		cardTitle: 'Unclaimed Baseline Spend',
		value: '$0.1M/2%',
		isLoading: false,
		icon: <UnclaimedBaselineSpend width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 3,
		cardTitle: 'Baseline Actioned',
		value: '$5.8M',
		isLoading: false,
		icon: <BaselineActioned width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 4,
		cardTitle: 'Responses Received',
		value: '0/100',
		isLoading: false,
		icon: <BaselineActioned width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 5,
		cardTitle: 'Responses Received (%)',
		value: '100%',
		isLoading: false,
		icon: <BaselineActioned width={25} height={25} />,
		isCurrency: false,
	},
];
export const PREWORKSHOP_VENDOR_DATA = [
	{
		key: 1,
		cardTitle: 'Eliminate',
		value: '$1.0M',
		isLoading: false,
		icon: <Eliminate width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 2,
		cardTitle: 'Reduce Demand',
		value: '1.3M',
		isLoading: false,
		icon: <ReduceDemand width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 3,
		cardTitle: 'Consolidate',
		value: '$0.2M',
		isLoading: false,
		icon: <Consolidate width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 4,
		cardTitle: 'Continue to use',
		value: '$3.3M',
		isLoading: false,
		icon: <ContinueToUse width={25} height={25} />,
		isCurrency: false,
	},
];
export const WORKSHOP_SUMMARY_DATA = [
	{
		key: 4,
		cardTitle: 'Eliminate',
		value: '$1.0M',
		isLoading: false,
		icon: <Eliminate width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 5,
		cardTitle: 'Reduce Demand',
		value: '1.3M',
		isLoading: false,
		icon: <ReduceDemand width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 6,
		cardTitle: 'Consolidate',
		value: '$0.2M',
		isLoading: false,
		icon: <Consolidate width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 7,
		cardTitle: 'Total Savings',
		value: '$1.5M',
		isLoading: false,
		icon: <FinalSignedSavings width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 8,
		cardTitle: 'Continue to use',
		value: '$3.3M',
		isLoading: false,
		icon: <ContinueToUse width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 9,
		cardTitle: 'Unclaimed',
		value: '$0.1M',
		isLoading: false,
		icon: <TotalSuppliers width={25} height={25} />,
		isCurrency: false,
	},
];
export const SAVINGS_SIGNS_OFF_SUMMARY_DATA = [
	{
		key: 4,
		cardTitle: 'Final Signed-off Savings',
		value: '$0M',
		isLoading: false,
		icon: <FinalSignedSavings width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 5,
		cardTitle: 'Final Signed-off Saving %',
		value: '1.3M',
		isLoading: false,
		icon: <FinalSignedPercent width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 6,
		cardTitle: 'Savings Pending Sign-off',
		value: '$0.2M',
		isLoading: false,
		icon: <SavingsPending width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 7,
		cardTitle: 'Records Pending Sign-off',
		value: '$1.5M',
		isLoading: false,
		icon: <SavingsPending width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 8,
		cardTitle: 'Total Lost Savings',
		value: '$0.1M',
		isLoading: false,
		icon: <TotalLostSavings width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 9,
		cardTitle: 'Total Lost Records',
		value: '6',
		isLoading: false,
		icon: <TotalLostRecords width={25} height={25} />,
		isCurrency: false,
	},
];
export const LOST_SAVINGS_SIGNS_OFF_SUMMARY_DATA = [
	{
		key: 6,
		cardTitle: 'Total Lost Savings',
		value: '$0.1M',
		isLoading: false,
		isCurrency: false,
	},
	{
		key: 7,
		cardTitle: 'Total Lost Records',
		value: '6',
		isLoading: false,
		isCurrency: false,
	},
];
export const MICROTAIL_BASELINE_SUMMARY_DATA = [
	{
		key: 0,
		cardTitle: 'Total Baseline Spend',
		value: '$5.9M',
		isLoading: false,
		icon: <TotalBaselineSpend width={25} height={25} />,
		isCurrency: true,
	},
	{
		key: 1,
		cardTitle: 'Baseline Spend Actioned',
		value: '$5.8M/98%',
		isLoading: false,
		icon: <BaselineActioned width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 2,
		cardTitle: 'Unclaimed Baseline Spend',
		value: '$0.1M/2%',
		isLoading: false,
		icon: <UnclaimedBaselineSpend width={25} height={25} />,
		isCurrency: false,
	},
];
export const MICROTAIL_VENDOR_DATA = [
	{
		key: 1,
		cardTitle: 'Continue to use',
		value: '$3.3M',
		isLoading: false,
		icon: <ContinueToUse width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 2,
		cardTitle: 'Eliminate',
		value: '$1.0M',
		isLoading: false,
		icon: <Eliminate width={25} height={25} />,
		isCurrency: false,
	},
];
export const BASELINE_SUMMARY_TITLE = 'BASELINE SUMMARY STATISTICS';
export const BASELINE_SUMMARY_COLUMNS = 6;

export const BASELINE_SUMMARY_ROWS = 1;

export const PREWORKSHOP_BASELINE_SUMMARY_TITLE =
	'PRE-WORKSHOP BASELINE SPEND SUMMARY';
export const MICROTAIL_BASELINE_SUMMARY_TITLE =
	'MICRO TAIL BASELINE SPEND SUMMARY BY VENDOR ACTION';
export const PREWORKSHOP_BASELINE_SUMMARY_COLUMNS = 6;
export const PREWORKSHOP_BASELINE_SUMMARY_ROWS = 1;
export const PREWORKSHOP_VENDOR_COLUMNS = 6;
export const PREWORKSHOP_VENDOR_ROWS = 1;
export const SAVINGS_SIGNS_OFFS_SUMMARY_COLUMNS = 2;
export const SAVINGS_SIGNS_OFFS_SUMMARY_ROWS = 1;
export const LOST_SAVINGS_SIGNS_OFFS_SUMMARY_COLUMNS = 2;
export const LOST_SAVINGS_SIGNS_OFFS_SUMMARY_ROWS = 1;
export const SAVINGS_SIGNS_OFFS_SUMMARY_TITLE = 'Signed-Off Savings';
export const PENDING_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE = 'Pending Signed-Off ';
export const LOST_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE = 'Lost Savings';
export const MICROTAIL_BASELINE_SUMMARY_COLUMNS = 6;
export const MICROTAIL_BASELINE_SUMMARY_ROWS = 1;

export const WORKSHOP_BASELINE_SUMMARY_TITLE =
	'WORKSHOP PRELIMINARY SAVING SUMMARY';

export const WORKSHOP_BASELINE_SUMMARY_COLUMNS = 6;
export const WORKSHOP_BASELINE_SUMMARY_ROWS = 1;
export const PRE_WORKSHOP_TITLE = 'PRE-WORKSHOP LIVE STATUS';

export const PRE_WORKSHOP_DATA = [
	{
		key: 0,
		cardTitle: 'Responses Received',
		value: '344/388',
		isLoading: false,
		icon: <ResponseReceived width={25} height={25} />,
		isCurrency: false,
	},
	{
		key: 1,
		cardTitle: 'Baseline Actioned',
		value: '$5.8M',
		isLoading: false,
		icon: <BaselineActioned width={25} height={25} />,
		isCurrency: true,
	},
	{
		key: 2,
		cardTitle: 'Preliminary Savings',
		value: '$1.5M',
		isLoading: false,
		icon: <PreliminarySavings width={25} height={25} />,
		isCurrency: true,
	},
	{
		key: 3,
		cardTitle: 'Responses Received(%)',
		value: '88.7%',
		isLoading: false,
		isCurrency: false,
		icon: <ResponsesPercent width={25} height={25} />,
		isPercent: true,
	},
	{
		key: 4,
		cardTitle: 'Baseline Actioned(%)',
		value: '97.5%',
		isPercent: true,
		icon: <BaselinePercent width={25} height={25} />,
		isLoading: false,
	},
	{
		key: 5,
		cardTitle: 'Preliminary Savings(%)',
		value: '25.4%',
		isLoading: false,
		isCurrency: false,
		icon: <PreliminarySavings width={25} height={25} />,
		isPercent: true,
	},
];

export const PRE_WORKSHOP_COLUMNS = 6;

export const PRE_WORKSHOP_ROWS = 1;

export const PRE_WORKSHOP_SUMMARY_DATA = [
	{
		key: 0,
		cardTitle: 'Preliminary Savings',
		value: 1.5,
		isLoading: false,
		icon: <PreliminarySavings width={25} height={25} />,
		isCurrency: true,
	},
	{
		key: 1,
		cardTitle: 'Preliminary Savings %',
		value: 25,
		isLoading: false,
		icon: <PreliminarySavings width={25} height={25} />,
		isCurrency: false,
		// isPercent:true
	},
];

export const MICRO_TAIL_SUMMARY_DATA = [
	{
		key: 0,
		cardTitle: 'Preliminary Savings',
		value: 1.5,
		isLoading: false,
		icon: <PreliminarySavings width={25} height={25} />,
		isCurrency: true,
	},
	{
		key: 1,
		cardTitle: 'Preliminary Savings %',
		value: 25,
		isLoading: false,
		icon: <PreliminarySavings width={25} height={25} />,
		isCurrency: false,
		// isPercent:true
	},
];
export const PRE_WORKSHOP_SUMMARY_COLUMNS = 6;

export const PRE_WORKSHOP_SUMMARY_ROWS = 1;

export const MICRO_TAIL_COLUMNS = 6;

export const MICRO_TAIL_ROWS = 1;

export const PRE_WORKSHOP_SUMMARY_TITLE =
	'PRE-WORKSHOP PRELIMINARY SAVINGS SUMMARY';
export const PREWORKSHOP_VENDOR_TITLE = 'IDENTIFIED VENDOR ACTIONS';
export const MICROTAIL_VENDOR_TITLE = 'IDENTIFIED VENDOR ACTIONS';
export const MICRO_TAIL_SUMMARY_TITLE =
	'PRE-WORKSHOP PRELIMINARY SAVINGS SUMMARY';

const TAILSPENDDROPDOWN = ['MACRO', 'MICRO', 'N/A'];
const YES_NO = ['YES', 'NO'];
const ACTION = [
	'Eliminate',
	'Reduce Demand',
	'Continue to use',
	'Consolidate',
	'N/A',
];
const MICRO_TAIL_ACTION = ['Eliminate', 'Continue to use', 'N/A'];
const PRIORITY = ['1', '2', '3', '4', 'N/A'];

const ADDRESSABLEDROPDOWN = ['ADDRESABLE', 'NON-ADDRESABLE', 'N/A'];
export const BASELINE_KPI_DATA = {
	data: BASELINE_SUMMARY_DATA,
	columns: BASELINE_SUMMARY_COLUMNS,
	rows: BASELINE_SUMMARY_ROWS,
	title: BASELINE_SUMMARY_TITLE,
};
export const PREWORKSHOP_KPI_DATA = {
	data: PRE_WORKSHOP_DATA,
	columns: PRE_WORKSHOP_COLUMNS,
	rows: PRE_WORKSHOP_ROWS,
	title: PRE_WORKSHOP_TITLE,
};
export const GL_HEADER = 'GL ACCOUNT PAYABLE GL DATA';

export const GL_REFRESH_HEADER = 'REFRESHED BASELINE/ANALYSIS';

const handleEmptyCellColor = params => {
	if (!params.value) {
		return { backgroundColor: colors.blue100 };
	}
	return { backgroundColor: 'inherit' };
};

export const BASELINE_COLUMN_HEADERS = [
	{
		headerName: 'ID',
		field: 'iD',
		colId: 'iD',
		filter: 'agNumberColumnFilter',
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		hide: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier ID',
		field: 'supplier_Id',
		colId: 'supplier_Id',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'SUPPLIER NAME',
		field: 'normalized_Vendor',
		colId: 'normalized_Vendor',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier Category Group',
		field: 'supplier_Description',
		colId: 'supplier_Description',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 1,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
		minWidth: 144,
	},
	{
		headerName: 'Supplier Details',
		field: 'supplier_Details',
		colId: 'supplier_Details',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 3,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Entity',
		field: 'entity',
		colId: 'entity',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Business Unit',
		field: 'business_Unit',
		colId: 'business_Unit',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Dept',
		field: 'department',
		colId: 'department',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Gl Account String',
		field: 'gl_Account_String',
		colId: 'gl_Account_String',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'GL Account Number',
		field: 'gl_Account_Number',
		colId: 'gl_Account_Number',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Account Desc',
		field: 'account_Description',
		colId: 'account_Description',
		suppressPaste: true,
		filter: false,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Entity Desc',
		field: 'entity_Description',
		colId: 'entity_Description',
		filter: false,
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Preliminary Spend Owner',
		field: 'spend_Owner',
		colId: 'spend_Owner',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		minWidth: 140,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Spend Dept',
		field: 'spend_Department',
		colId: 'spend_Department',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},

	{
		headerName: 'Spend',
		field: 'spend',
		colId: 'spend',
		filter: 'agNumberColumnFilter',
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.spend !== 0
				? spendFormatter(params.data?.spend, true)
				: '-';
		},
		suppressPaste: true,
	},
	{
		headerName: 'Workshop ID',
		field: 'workshop_key',
		colId: 'workshop_key',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'WorkShop Name',
		field: 'workshop_Name',
		colId: 'workshop_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: [],
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
	{
		headerName: 'CapEx Flag',
		field: 'capEx_Flag',
		colId: 'capEx_Flag',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: YES_NO,
		},
		valueSetter: params => {
			if (YES_NO.includes(params.newValue)) {
				const newVal = params.newValue;
				const valueChanged = params.data?.capEx_Flag !== newVal;
				if (valueChanged) {
					params.data.capEx_Flag = newVal;
				}
				return valueChanged;
			}
			return false;
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
	{
		headerName: 'Macro Tail Spend BreakDown',
		field: 'macro_Tail_Spend_Breakdown',
		colId: 'macro_Tail_Spend_Breakdown',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		minWidth: 160,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 1,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Micro Tail Spend BreakDown',
		field: 'micro_Tail_Spend_Breakdown',
		colId: 'micro_Tail_Spend_Breakdown',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		minWidth: 150,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 1,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Tail Spend Type',
		field: 'tail_Spend_Type',
		colId: 'tail_Spend_Type',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressMenu: true,
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: TAILSPENDDROPDOWN,
		},
		valueSetter: params => {
			if (TAILSPENDDROPDOWN.includes(params.newValue)) {
				const newVal = params.newValue;
				const valueChanged = params.data?.tail_Spend_Type !== newVal;
				if (valueChanged) {
					params.data.tail_Spend_Type = newVal;
				}
				return valueChanged;
			}
			return false;
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
	{
		headerName: 'Addressable',
		field: 'addressable',
		colId: 'addressable',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: ADDRESSABLEDROPDOWN,
		},
		valueSetter: params => {
			if (ADDRESSABLEDROPDOWN.includes(params.newValue)) {
				const newVal = params.newValue;
				const valueChanged = params.data?.addressable !== newVal;
				if (valueChanged) {
					params.data.addressable = newVal;
				}
				return valueChanged;
			}
			return false;
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
	{
		headerName: 'Final Category',
		field: 'final_Category',
		colId: 'final_Category',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Final Sub Category',
		field: 'final_Subcategory',
		colId: 'final_Subcategory',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 1,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
];
export const PREWORKSHOP_COLUMN_HEADERS = [
	{
		headerName: 'Workshop ID',
		field: 'workshop_key',
		colId: 'workshop_key',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'WorkShop Name',
		field: 'workshop_Name',
		colId: 'workshop_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier ID',
		field: 'supplier_Id',
		colId: 'supplier_Id',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier Name',
		field: 'normalized_Vendor',
		colId: 'normalized_Vendor',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier Category Group',
		field: 'supplier_Description',
		colId: 'supplier_Description',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
		minWidth: 144,
	},
	{
		headerName: 'Supplier Details',
		field: 'supplier_Details',
		colId: 'supplier_Details',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'concatenatedIds',
		field: 'concatenatedIds',
		colId: 'concatenatedIds',
		hide: true,
	},
	{
		headerName: 'Preliminary Spend Owner',
		field: 'spend_Owner',
		colId: 'spend_Owner',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		minWidth: 140,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'SPEND',
		field: 'spend',
		colId: 'spend',
		// suppressMenu: true,
		filter: 'agNumberColumnFilter',
		suppressPaste: true,
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},

		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.spend !== 0
				? spendFormatter(params.data?.spend, true)
				: '-';
		},
	},
	{
		headerName: 'Please Edit the below Columns',
		headerClass: 'header-ag-blue',
		children: [
			{
				headerName: 'Is This Your Vendor',
				field: 'is_this_Your_Vendor',
				colId: 'is_this_Your_Vendor',
				filter: 'agSetColumnFilter',
				filterParams: {
					values: [],
				},
				editable: true,
				cellStyle: handleEmptyCellColor,
				cellEditor: 'agRichSelectCellEditor',
				singleClickEdit: true,
				cellEditorParams: {
					values: YES_NO,
				},
				valueSetter: params => {
					if (YES_NO.includes(params.newValue)) {
						const newVal = params.newValue;
						const valueChanged = params.data?.is_this_Your_Vendor !== newVal;
						if (valueChanged) {
							params.data.is_this_Your_Vendor = newVal;
						}
						return valueChanged;
					}
					return false;
				},
				headerClass: 'header-ag-blue',
				cellClass: 'dropdown-cell',
			},
			{
				headerName: 'Final Spend Owner Name',
				field: 'final_Spend_Owner_Name',
				colId: 'final_Spend_Owner_Name',
				filter: 'agSetColumnFilter',
				filterParams: {
					values: [],
				},
				editable: true,
				cellStyle: handleEmptyCellColor,
				cellEditor: 'agLargeTextCellEditor',
				cellEditorPopup: true,
				cellEditorParams: {
					rows: 1,
					cols: 40,
				},
				headerClass: 'header-ag-blue',
			},
			{
				headerName: 'is this vendor business critical',
				field: 'is_this_vendor_business_critical',
				colId: 'is_this_vendor_business_critical',
				filter: 'agSetColumnFilter',
				filterParams: {
					values: [],
				},
				editable: true,
				minWidth: 160,
				cellStyle: handleEmptyCellColor,
				cellEditor: 'agRichSelectCellEditor',
				singleClickEdit: true,
				cellEditorParams: {
					values: YES_NO,
				},
				valueSetter: params => {
					if (YES_NO.includes(params.newValue)) {
						const newVal = params.newValue;
						const valueChanged =
							params.data.is_this_vendor_business_critical !== newVal;
						if (valueChanged) {
							params.data.is_this_vendor_business_critical = newVal;
						}
						return valueChanged;
					}
					return false;
				},
				headerClass: 'header-ag-blue',
				cellClass: 'dropdown-cell',
			},
			{
				headerName: 'Recommended Action',
				field: 'recommended_Action',
				colId: 'recommended_Action',
				filter: 'agSetColumnFilter',
				filterParams: {
					values: [],
				},
				editable: true,
				cellStyle: handleEmptyCellColor,
				cellEditor: 'agRichSelectCellEditor',
				singleClickEdit: true,
				cellEditorParams: {
					values: ACTION,
				},
				valueSetter: params => {
					if (ACTION.includes(params.newValue)) {
						const newVal = params.newValue;
						const valueChanged = params.data?.recommended_Action !== newVal;
						if (valueChanged) {
							params.data.recommended_Action = newVal;
						}
						return valueChanged;
					}
					return false;
				},
				headerClass: 'header-ag-blue',
				cellClass: 'dropdown-cell',
			},
			{
				headerName: 'Savings Percentage',
				field: 'savings_opportunity',
				colId: 'savings_opportunity',
				filter: 'agNumberColumnFilter',
				filterParams: {
					values: [],
					filterOptions: [
						'equals',
						'notEqual',
						'lessThan',
						'lessThanOrEqual',
						'greaterThan',
						'greaterThanOrEqual',
					],
				},
				editable: true,
				cellStyle: handleEmptyCellColor,
				valueGetter: params => {
					return percentFormatter(params.data?.savings_opportunity);
				},
				headerClass: 'header-ag-blue',
			},
			{
				headerName: 'Total Savings',
				field: 'total_Savings',
				colId: 'total_Savings',
				filter: 'agNumberColumnFilter',
				filterParams: {
					values: [],
					filterOptions: [
						'equals',
						'notEqual',
						'lessThan',
						'lessThanOrEqual',
						'greaterThan',
						'greaterThanOrEqual',
					],
				},
				valueGetter: params => {
					return params.data?.spend !== 0
						? spendFormatter(params.data?.total_Savings, true)
						: '-';
				},
				suppressPaste: true,
				// headerClass: 'header-ag-blue',
			},

			// {
			// 	headerName: 'Remaining Budget ',
			// 	field: 'remaining_Spend_Pre',
			// 	colId: 'remaining_Spend_Pre',
			// 	filter: 'agNumberColumnFilter',
			// 	filterParams: {
			// 		values: [],
			// 		filterOptions: [
			// 			'equals',
			// 			'notEqual',
			// 			'lessThan',
			// 			'lessThanOrEqual',
			// 			'greaterThan',
			// 			'greaterThanOrEqual',
			// 		],
			// 	},
			// 	valueGetter: params => {
			// 		return params.data?.remaining_Spend_Pre !== 0
			// 			? spendFormatter(params.data?.remaining_Spend_Pre, true)
			// 			: '-';
			// 	},
			// 	suppressPaste: true,
			// },
			{
				headerName: 'SpendOwner Comments',
				field: 'spend_Owner_Comments',
				colId: 'spend_Owner_Comments',
				filter: 'agSetColumnFilter',
				filterParams: {
					values: [],
				},
				editable: true,
				cellStyle: handleEmptyCellColor,
				cellEditor: 'agLargeTextCellEditor',
				cellEditorPopup: true,
				cellEditorParams: {
					rows: 3,
					cols: 40,
				},
				headerClass: 'header-ag-blue',
			},
		],
	},
];
export const BASELINE_GRAPHQL_DATA = {
	columnDefs: BASELINE_COLUMN_HEADERS,
	cteModel: [],
	primaryTable: '[sxr].[SPEND_CONTROLLER] a',
	rowGroups: [
		{ id: '1', displayName: 'iD', field: 'iD', selector: 'a' },
		{
			id: '2',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'a',
		},
		{
			id: '3',
			displayName: 'gl_Account_String',
			field: 'gl_Account_String',
			selector: 'a',
		},
		{ id: '4', displayName: 'entity', field: 'entity', selector: 'a' },
		{
			id: '5',
			displayName: 'business_Unit',
			field: 'business_Unit',
			selector: 'a',
		},
		{ id: '6', displayName: 'department', field: 'department', selector: 'a' },
		{
			id: '7',
			displayName: 'spend_Owner',
			field: 'spend_Owner',
			selector: 'a',
		},
		{
			id: '8',
			displayName: 'spend_Department',
			field: 'spend_Department',
			selector: 'a',
		},
		{
			id: '9',
			displayName: 'gl_Account_Number',
			field: 'gl_Account_Number',
			selector: 'a',
		},
		{
			id: '10',
			displayName: 'account_Description',
			field: 'account_Description',
			selector: 'a',
		},
		{
			id: '11',
			displayName: 'entity_Description',
			field: 'entity_Description',
			selector: 'a',
		},
		{ id: '12', displayName: 'spend', field: 'spend', selector: 'a' },
		{
			id: '13',
			displayName: 'tail_Spend_Type',
			field: 'tail_Spend_Type',
			selector: 'a',
		},
		{
			id: '14',
			displayName: 'addressable',
			field: 'addressable',
			selector: 'a',
		},
		{
			id: '15',
			displayName: 'final_Category',
			field: 'final_Category',
			selector: 'a',
		},
		{
			id: '16',
			displayName: 'final_Subcategory',
			field: 'final_Subcategory',
			selector: 'a',
		},
		{
			id: '17',
			displayName: 'workshop_id',
			field: 'workshop_id',
			selector: 'a',
		},
		{
			id: '18',
			displayName: 'workshop_key',
			field: 'workshop_key',
			selector: 'a',
		},
		{
			id: '19',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'a',
		},
		{ id: '20', displayName: 'capEx_Flag', field: 'capEx_Flag', selector: 'a' },
		{
			id: '21',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'a',
		},
		{
			id: '22',
			displayName: 'macro_Tail_Spend_Breakdown',
			field: 'macro_Tail_Spend_Breakdown',
			selector: 'a',
		},
		{
			id: '23',
			displayName: 'micro_Tail_Spend_Breakdown',
			field: 'micro_Tail_Spend_Breakdown',
			selector: 'a',
		},
		{
			id: '24',
			displayName: 'addressable',
			field: 'addressable',
			selector: 'a',
		},
		{
			id: '25',
			displayName: 'is_this_Your_Vendor',
			field: 'is_this_Your_Vendor',
			selector: 'a',
		},
		{
			id: '26',
			displayName: 'recommended_Action',
			field: 'recommended_Action',
			selector: 'a',
		},
		{
			id: '27',
			displayName: 'savings_opportunity',
			field: 'savings_opportunity',
			selector: 'a',
		},
		{
			id: '28',
			displayName: 'spend_Owner_Comments',
			field: 'spend_Owner_Comments',
			selector: 'a',
		},
		{
			id: '29',
			displayName: 'total_Savings',
			field: 'total_Savings',
			selector: 'a',
		},
		{
			id: '30',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'a',
		},
		{
			id: '31',
			displayName: 'is_this_vendor_business_critical',
			field: 'is_this_vendor_business_critical',
			selector: 'a',
		},
		{
			id: '32',
			displayName: 'final_Supplier_Action',
			field: 'final_Supplier_Action',
			selector: 'a',
		},
		{
			id: '33',
			displayName: 'new_Reduction',
			field: 'new_Reduction',
			selector: 'a',
		},
		{
			id: '34',
			displayName: 'workshop_Comments',
			field: 'workshop_Comments',
			selector: 'a',
		},
		{
			id: '35',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'a',
		},
		{
			id: '36',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'a',
		},
	],
	filterModel: [],
	caseModel: [],
	valueCols: [],
	joinModel: [],
	havingModel: [],
	groupCols: [],
};
export const PREWORKSHOP_GRAPHQL_DATA = {
	columnDefs: PREWORKSHOP_COLUMN_HEADERS,
	cteModel: [],
	primaryTable: '[sxr].[SPEND_CONTROLLER] a',
	rowGroups: [
		{ id: '1', displayName: 'iD', field: 'iD', selector: 'a', concat: true },
		{
			id: '2',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'a',
		},
		{
			id: '3',
			displayName: 'is_this_Your_Vendor',
			field: 'is_this_Your_Vendor',
			selector: 'a',
		},
		{
			id: '4',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'a',
		},
		{
			id: '5',
			displayName: 'is_this_vendor_business_critical',
			field: 'is_this_vendor_business_critical',
			selector: 'a',
		},
		{
			id: '6',
			displayName: 'recommended_Action',
			field: 'recommended_Action',
			selector: 'a',
		},
		{
			id: '7',
			displayName: 'savings_opportunity',
			field: 'savings_opportunity',
			selector: 'a',
		},
		{
			id: '8',
			displayName: 'spend_Owner_Comments',
			field: 'spend_Owner_Comments',
			selector: 'a',
		},
		{
			id: '9',
			displayName: 'spend_Owner',
			field: 'spend_Owner',
			selector: 'a',
		},
		{
			id: '10',
			displayName: 'workshop_key',
			field: 'workshop_key',
			selector: 'a',
		},
		{
			id: '11',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'a',
		},
		{
			id: '12',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'a',
		},
		{
			id: '13',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'a',
		},
		{
			id: '14',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'a',
		},
	],
	caseModel: [],
	valueCols: [
		{
			id: '1',
			aggFunc: 'sum',
			displayName: 'spend',
			field: 'spend',
			selector: 'a',
			alias: 'spend',
		},
		{
			id: '2',
			aggFunc: 'sum',
			displayName: 'total_Savings',
			field: 'total_Savings',
			selector: 'a',
			alias: 'total_Savings',
		},
		{
			id: '3',
			aggFunc: 'sum',
			displayName: 'remaining_Spend_Pre',
			field: 'remaining_Spend_Pre',
			selector: 'a',
			alias: 'remaining_Spend_Pre',
		},
	],
	joinModel: [],
	havingModel: [],
	filterModel: [],
	groupCols: [
		{
			id: '1',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'a',
		},
		{
			id: '2',
			displayName: 'spend_Owner',
			field: 'spend_Owner',
			selector: 'a',
		},
		{
			id: '3',
			displayName: 'is_this_Your_Vendor',
			field: 'is_this_Your_Vendor',
			selector: 'a',
		},
		{
			id: '4',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'a',
		},
		{
			id: '5',
			displayName: 'is_this_vendor_business_critical',
			field: 'is_this_vendor_business_critical',
			selector: 'a',
		},
		{
			id: '6',
			displayName: 'recommended_Action',
			field: 'recommended_Action',
			selector: 'a',
		},
		{
			id: '7',
			displayName: 'savings_opportunity',
			field: 'savings_opportunity',
			selector: 'a',
		},
		{
			id: '8',
			displayName: 'spend_Owner_Comments',
			field: 'spend_Owner_Comments',
			selector: 'a',
		},
		{
			id: '10',
			displayName: 'workshop_key',
			field: 'workshop_key',
			selector: 'a',
		},
		{
			id: '11',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'a',
		},
		{
			id: '12',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'a',
		},
		{
			id: '13',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'a',
		},
		{
			id: '14',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'a',
		},
	],
};
export const WORKSHOP_COLUMN_HEADERS = [
	{
		headerName: 'Workshop ID',
		field: 'workshop_key',
		colId: 'workshop_key',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'WorkShop Name',
		field: 'workshop_Name',
		colId: 'workshop_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier ID',
		field: 'supplier_Id',
		colId: 'supplier_Id',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'SUPPLIER NAME',
		field: 'normalized_Vendor',
		colId: 'normalized_Vendor',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier Category Group',
		field: 'supplier_Description',
		colId: 'supplier_Description',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
		minWidth: 144,
	},
	{
		headerName: 'Supplier Details',
		field: 'supplier_Details',
		colId: 'supplier_Details',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'concatenatedIds',
		field: 'concatenatedIds',
		colId: 'concatenatedIds',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		hide: true,
	},

	{
		headerName: 'Preliminary Spend Owner',
		field: 'spend_Owner',
		colId: 'spend_Owner',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		minWidth: 140,
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Spend',
		field: 'spend',
		colId: 'spend',
		filter: 'agNumberColumnFilter',
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.spend !== 0
				? spendFormatter(params.data?.spend, true)
				: '-';
		},
	},
	{
		headerName: 'Is This Your Vendor',
		field: 'is_this_Your_Vendor',
		colId: 'is_this_Your_Vendor',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		// headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Final Spend Owner Name',
		field: 'final_Spend_Owner_Name',
		colId: 'final_Spend_Owner_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 1,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Is This Vendor Business Critical',
		field: 'is_this_vendor_business_critical',
		colId: 'is_this_vendor_business_critical',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		minWidth: 155,
		suppressPaste: true,
		// headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Recommended Action',
		field: 'recommended_Action',
		colId: 'recommended_Action',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		// headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Total Savings',
		field: 'total_Savings',
		colId: 'total_Savings',
		filter: 'agNumberColumnFilter',
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		valueGetter: params => {
			return params.data?.total_Savings !== 0
				? spendFormatter(params.data?.total_Savings, true)
				: '-';
		},
		suppressPaste: true,
		// headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Savings Percentage',
		field: 'savings_opportunity',
		colId: 'savings_opportunity',
		filter: 'agNumberColumnFilter',
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		valueGetter: params => {
			return percentFormatter(params.data?.savings_opportunity);
		},
		suppressPaste: true,
		// headerClass: 'header-ag-blue',
	},

	{
		headerName: 'Spend Owner Comments',
		field: 'spend_Owner_Comments',
		colId: 'spend_Owner_Comments',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		minWidth: 150,
		// headerClass: 'header-ag-blue',
	},
	// {
	// 	headerName: 'Total Savings',
	// 	field: 'total_Savings',
	// 	colId: 'total_Savings',
	// 	filter: 'agNumberColumnFilter',
	// 	filterParams: {
	// 		values: [],
	// 		filterOptions: [
	// 			'equals',
	// 			'notEqual',
	// 			'lessThan',
	// 			'lessThanOrEqual',
	// 			'greaterThan',
	// 			'greaterThanOrEqual',
	// 		],
	// 	},
	// 	valueGetter: params => {
	// 		return params.data?.total_Savings !== 0
	// 			? spendFormatter(params.data?.total_Savings, true)
	// 			: '-';
	// 	},
	// 	// headerClass: 'header-ag-blue',
	// },
	{
		headerName: 'Workshop Priority',
		field: 'workshop_Priority',
		colId: 'workshop_Priority',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: PRIORITY,
		},
		valueSetter: params => {
			if (PRIORITY.includes(params.newValue)) {
				const newVal = params.newValue;
				const valueChanged = params.data?.workshop_Priority !== newVal;
				if (valueChanged) {
					params.data.workshop_Priority = newVal;
				}
				return valueChanged;
			}
			return false;
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
	{
		headerName: 'Savings Categorization',
		field: 'savings_Categorization',
		colId: 'savings_Categorization',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		minWidth: 150,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 3,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Final Supplier Action',
		field: 'final_Supplier_Action',
		colId: 'final_Supplier_Action',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		minWidth: 150,
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: ACTION,
		},
		valueSetter: params => {
			if (ACTION.includes(params.newValue)) {
				const newVal = params.newValue;
				const valueChanged = params.data?.final_Supplier_Action !== newVal;
				if (valueChanged) {
					params.data.final_Supplier_Action = newVal;
				}
				return valueChanged;
			}
			return false;
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
	{
		headerName: 'Confirmed Reduction',
		field: 'new_Reduction',
		colId: 'new_Reduction',
		filter: 'agNumberColumnFilter',
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		valueGetter: params => {
			return percentFormatter(params.data?.new_Reduction);
		},
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Final Savings',
		field: 'final_Savings',
		colId: 'final_Savings',
		filter: 'agNumberColumnFilter',
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.final_Savings !== 0
				? spendFormatter(params.data.final_Savings, true)
				: '-';
		},
	},
	// {
	// 	headerName: 'Remaining Budget ',
	// 	field: ' remaining_Spend_Wor',
	// 	colId: ' remaining_Spend_Wor',
	// 	filter: 'agNumberColumnFilter',
	// 	filterParams: {
	// 		values: [],
	// 		filterOptions: [
	// 			'equals',
	// 			'notEqual',
	// 			'lessThan',
	// 			'lessThanOrEqual',
	// 			'greaterThan',
	// 			'greaterThanOrEqual',
	// 		],
	// 	},
	// 	valueGetter: params => {
	// 		return params.data?.remaining_Spend_Wor !== null
	// 			? spendFormatter(params.data?.remaining_Spend_Wor, true)
	// 			: '-';
	// 	},
	// 	suppressPaste: true,
	// },
	{
		headerName: 'Workshop Comments',
		field: 'workshop_Comments',
		colId: 'workshop_Comments',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 3,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Key Workshop Changes',
		field: 'key_Workshop_Changes',
		colId: 'key_Workshop_Changes',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 3,
			cols: 40,
		},
		minWidth: 150,
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Remove From Supplier List',
		field: 'remove_From_Supplier_List',
		colId: 'remove_From_Supplier_List',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: YES_NO,
		},
		minWidth: 170,
		valueSetter: params => {
			if (YES_NO.includes(params.newValue)) {
				const newVal = params.newValue;
				const valueChanged = params.data?.remove_From_Supplier_List !== newVal;
				if (valueChanged) {
					params.data.remove_From_Supplier_List = newVal;
				}
				return valueChanged;
			}
			return false;
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
];

export const WORKSHOP_GRAPHQL_DATA = {
	columnDefs: WORKSHOP_COLUMN_HEADERS,
	cteExist: false,
	primaryTable: '[sxr].[SPEND_CONTROLLER] p',
	rowGroups: [
		{ id: '1', displayName: 'iD', field: 'iD', selector: 'p', concat: true },
		{
			id: '2',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'p',
		},
		{
			id: '3',
			displayName: 'is_this_Your_Vendor',
			field: 'is_this_Your_Vendor',
			selector: 'p',
		},
		{
			id: '4',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'p',
		},
		{
			id: '5',
			displayName: 'is_this_vendor_business_critical',
			field: 'is_this_vendor_business_critical',
			selector: 'p',
		},
		{
			id: '6',
			displayName: 'recommended_Action',
			field: 'recommended_Action',
			selector: 'p',
		},
		{
			id: '7',
			displayName: 'savings_opportunity',
			field: 'savings_opportunity',
			selector: 'p',
		},
		{
			id: '8',
			displayName: 'spend_Owner_Comments',
			field: 'spend_Owner_Comments',
			selector: 'p',
		},
		{
			id: '9',
			displayName: 'spend_Owner',
			field: 'spend_Owner',
			selector: 'p',
		},
		{
			id: '10',
			displayName: 'workshop_Priority',
			field: 'workshop_Priority',
			selector: 'p',
		},
		{
			id: '11',
			displayName: 'savings_Categorization',
			field: 'savings_Categorization',
			selector: 'p',
		},
		{
			id: '12',
			displayName: 'final_Supplier_Action',
			field: 'final_Supplier_Action',
			selector: 'p',
		},
		{
			id: '13',
			displayName: 'new_Reduction',
			field: 'new_Reduction',
			selector: 'p',
		},
		{
			id: '14',
			displayName: 'workshop_Comments',
			field: 'workshop_Comments',
			selector: 'p',
		},
		{
			id: '15',
			displayName: 'key_Workshop_Changes',
			field: 'key_Workshop_Changes',
			selector: 'p',
		},
		{
			id: '16',
			displayName: 'remove_From_Supplier_List',
			field: 'remove_From_Supplier_List',
			selector: 'p',
		},
		{
			id: '17',
			displayName: 'workshop_key',
			field: 'workshop_key',
			selector: 'p',
		},
		{
			id: '18',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'p',
		},
		{
			id: '19',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'p',
		},
		{
			id: '20',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'p',
		},
		{
			id: '21',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'p',
		},
	],
	caseModel: [],
	valueCols: [
		{
			id: '1',
			aggFunc: 'sum',
			displayName: 'spend',
			field: 'spend',
			selector: 'p',
			alias: 'spend',
		},
		{
			id: '2',
			aggFunc: 'sum',
			displayName: 'total_Savings',
			field: 'total_Savings',
			selector: 'p',
			alias: 'total_Savings',
		},
		{
			id: '3',
			aggFunc: 'sum',
			displayName: 'remaining_Spend_Wor',
			field: 'remaining_Spend_Wor',
			selector: 'p',
			alias: 'remaining_Spend_Wor',
		},
		{
			id: '4',
			aggFunc: 'sum',
			displayName: 'final_Savings',
			field: 'final_Savings',
			selector: 'p',
			alias: 'final_Savings',
		},
	],
	filterModel: [],
	joinModel: [],
	havingModel: [],

	groupCols: [
		{
			id: '1',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'p',
		},
		{
			id: '2',
			displayName: 'spend_Owner',
			field: 'spend_Owner',
			selector: 'p',
		},
		{
			id: '3',
			displayName: 'is_this_Your_Vendor',
			field: 'is_this_Your_Vendor',
			selector: 'p',
		},
		{
			id: '4',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'p',
		},
		{
			id: '5',
			displayName: 'is_this_vendor_business_critical',
			field: 'is_this_vendor_business_critical',
			selector: 'p',
		},
		{
			id: '6',
			displayName: 'recommended_Action',
			field: 'recommended_Action',
			selector: 'p',
		},
		{
			id: '7',
			displayName: 'savings_opportunity',
			field: 'savings_opportunity',
			selector: 'p',
		},
		{
			id: '8',
			displayName: 'spend_Owner_Comments',
			field: 'spend_Owner_Comments',
			selector: 'p',
		},
		{
			id: '9',
			displayName: 'workshop_Priority',
			field: 'workshop_Priority',
			selector: 'p',
		},
		{
			id: '10',
			displayName: 'savings_Categorization',
			field: 'savings_Categorization',
			selector: 'p',
		},
		{
			id: '11',
			displayName: 'final_Supplier_Action',
			field: 'final_Supplier_Action',
			selector: 'p',
		},
		{
			id: '12',
			displayName: 'new_Reduction',
			field: 'new_Reduction',
			selector: 'p',
		},
		{
			id: '13',
			displayName: 'workshop_Comments',
			field: 'workshop_Comments',
			selector: 'p',
		},
		{
			id: '14',
			displayName: 'key_Workshop_Changes',
			field: 'key_Workshop_Changes',
			selector: 'p',
		},
		{
			id: '15',
			displayName: 'remove_From_Supplier_List',
			field: 'remove_From_Supplier_List',
			selector: 'p',
		},
		{
			id: '16',
			displayName: 'workshop_key',
			field: 'workshop_key',
			selector: 'p',
		},
		{
			id: '17',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'p',
		},
		{
			id: '18',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'p',
		},
		{
			id: '19',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'p',
		},
		{
			id: '20',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'p',
		},
	],
};

export const SAVINGS_SIGN_OFF_COLUMN_HEADERS = [
	{
		headerName: 'Workshop ID',
		field: 'workshop_key',
		colId: 'workshop_key',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'WorkShop Name',
		field: 'workshop_Name',
		colId: 'workshop_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier ID',
		field: 'supplier_Id',
		colId: 'supplier_Id',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'SUPPLIER NAME',
		field: 'normalized_Vendor',
		colId: 'normalized_Vendor',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier Category Group',
		field: 'supplier_Description',
		colId: 'supplier_Description',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
		minWidth: 144,
	},
	{
		headerName: 'Supplier Details',
		field: 'supplier_Details',
		colId: 'supplier_Details',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'concatenatedIds',
		field: 'concatenatedIds',
		colId: 'concatenatedIds',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		hide: true,
	},

	{
		headerName: 'Final Spend Owner Name ',
		field: 'final_Spend_Owner_Name',
		colId: 'final_Spend_Owner_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Spend',
		field: 'spend',
		colId: 'spend',
		filter: 'agNumberColumnFilter',
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.spend !== 0
				? spendFormatter(params.data?.spend, true)
				: '-';
		},
	},
	{
		headerName: 'Spend Owner Comments',
		field: 'spend_Owner_Comments',
		colId: 'spend_Owner_Comments',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		minWidth: 150,
		headerClass: 'header-ag-green',
	},
	{
		headerName: ' Confirmed Reduction',
		field: 'new_Reduction',
		colId: 'new_Reduction',
		filter: 'agNumberColumnFilter',
		suppressPaste: true,
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		valueGetter: params => {
			return percentFormatter(params.data?.new_Reduction);
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Workshop Comments',
		field: 'workshop_Comments',
		colId: 'workshop_Comments',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'FINAL SUPPLIER ACTION',
		field: 'final_Supplier_Action',
		colId: 'final_Supplier_Action',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		minWidth: 150,
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Final Savings',
		field: 'final_Savings',
		colId: 'final_Savings',
		filter: 'agNumberColumnFilter',
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		valueGetter: params => {
			return params.data?.final_Savings !== 0
				? spendFormatter(params.data?.final_Savings, true)
				: '-';
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'De-Active from Vendor Master',
		field: 'deactive_From_Vendor_Master',
		colId: 'deactive_From_Vendor_Master',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		minWidth: 150,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: YES_NO,
		},
		valueSetter: params => {
			if (YES_NO.includes(params.newValue)) {
				const newVal = params.newValue;
				const valueChanged =
					params.data?.deactive_From_Vendor_Master !== newVal;
				if (valueChanged) {
					params.data.deactive_From_Vendor_Master = newVal;
				}
				return valueChanged;
			}
			return false;
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
	{
		headerName: 'Final Sign Off',
		field: 'input_Initial_For_Final_Sign_Off',
		colId: 'input_Initial_For_Final_Sign_Off',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 1,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'Additional Context',
		field: 'enter_Additional_Context',
		colId: 'enter_Additional_Context',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 3,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
	// {
	// 	headerName: 'Is Lost Savings?',
	// 	field: 'is_Loss_Savings',
	// 	colId: 'is_Loss_Savings',
	// 	filter: false,
	// 	editable: true,
	// 	cellEditor: 'agSelectCellEditor',
	// 	cellEditorParams: {
	// 		values: YES_NO,
	// 	},
	// 	valueSetter: params => {
	// 		if (YES_NO.includes(params.newValue)) {
	// 			const newVal = params.newValue;
	// 			const valueChanged = params.data?.is_Loss_Savings !== newVal;
	// 			if (valueChanged) {
	// 				params.data.is_Loss_Savings = newVal;
	// 			}
	// 			return valueChanged;
	// 		}
	// 		return false;
	// 	},
	// 	headerClass: 'header-ag-blue',
	// 	cellClass: 'dropdown-cell',
	// },
];

export const SAVINGS_SIGN_OFF_GRAPHQL_DATA = {
	columnDefs: SAVINGS_SIGN_OFF_COLUMN_HEADERS,
	cteExist: false,
	primaryTable: '[sxr].[SPEND_CONTROLLER] p',
	rowGroups: [
		{ id: '1', displayName: 'iD', field: 'iD', selector: 'p', concat: true },
		{
			id: '2',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'p',
		},
		{
			id: '3',
			displayName: 'spend_Owner_Comments',
			field: 'spend_Owner_Comments',
			selector: 'p',
		},
		{
			id: '4',
			displayName: 'new_Reduction',
			field: 'new_Reduction',
			selector: 'p',
		},
		{
			id: '5',
			displayName: 'final_Supplier_Action',
			field: 'final_Supplier_Action',
			selector: 'p',
		},
		{
			id: '6',
			displayName: 'workshop_Comments',
			field: 'workshop_Comments',
			selector: 'p',
		},
		{
			id: '7',
			displayName: 'deactive_From_Vendor_Master',
			field: 'deactive_From_Vendor_Master',
			selector: 'p',
		},
		{
			id: '8',
			displayName: 'input_Initial_For_Final_Sign_Off',
			field: 'input_Initial_For_Final_Sign_Off',
			selector: 'p',
		},
		{
			id: '9',
			displayName: 'enter_Additional_Context',
			field: 'enter_Additional_Context',
			selector: 'p',
		},
		{
			id: '10',
			displayName: 'is_Loss_Savings',
			field: 'is_Loss_Savings',
			selector: 'p',
		},
		{
			id: '11',
			displayName: 'workshop_key',
			field: 'workshop_key',
			selector: 'p',
		},
		{
			id: '12',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'p',
		},
		{
			id: '13',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'p',
		},
		{
			id: '14',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'p',
		},
		{
			id: '15',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'p',
		},
		{
			id: '16',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'p',
		},
	],
	caseModel: [],
	filterModel: [
		{
			final_Supplier_Action: {
				values: ['Eliminate', 'Reduce Demand', 'Consolidate'],
				filterType: 'set',
			},
		},
	],
	valueCols: [
		{
			id: '1',
			aggFunc: 'sum',
			displayName: 'spend',
			field: 'spend',
			selector: 'p',
			alias: 'spend',
		},
		{
			id: '1',
			aggFunc: 'sum',
			displayName: 'final_Savings',
			field: 'final_Savings',
			selector: '',
			alias: 'final_Savings',
		},
	],
	joinModel: [],
	havingModel: [],

	groupCols: [
		{
			id: '1',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'p',
		},
		{
			id: '2',
			displayName: 'spend_Owner_Comments',
			field: 'spend_Owner_Comments',
			selector: 'p',
		},
		{
			id: '3',
			displayName: 'new_Reduction',
			field: 'new_Reduction',
			selector: 'p',
		},
		{
			id: '4',
			displayName: 'final_Supplier_Action',
			field: 'final_Supplier_Action',
			selector: 'p',
		},
		{
			id: '5',
			displayName: 'workshop_Comments',
			field: 'workshop_Comments',
			selector: 'p',
		},
		{
			id: '6',
			displayName: 'deactive_From_Vendor_Master',
			field: 'deactive_From_Vendor_Master',
			selector: 'p',
		},
		{
			id: '7',
			displayName: 'input_Initial_For_Final_Sign_Off',
			field: 'input_Initial_For_Final_Sign_Off',
			selector: 'p',
		},
		{
			id: '8',
			displayName: 'enter_Additional_Context',
			field: 'enter_Additional_Context',
			selector: 'p',
		},
		{
			id: '9',
			displayName: 'is_Loss_Savings',
			field: 'is_Loss_Savings',
			selector: 'p',
		},
		{
			id: '10',
			displayName: 'workshop_key',
			field: 'workshop_key',
			selector: 'p',
		},
		{
			id: '11',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'p',
		},
		{
			id: '12',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'p',
		},
		{
			id: '13',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'p',
		},
		{
			id: '14',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'p',
		},
		{
			id: '15',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'p',
		},
	],
};

export const MICRO_LAUNCH_COLUMN_HEADERS = [
	{
		headerName: 'concatenatedIds',
		field: 'concatenatedIds',
		colId: 'concatenatedIds',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		hide: true,
	},

	{
		headerName: 'Preliminary Spend Owner',
		field: 'spend_Owner',
		colId: 'spend_Owner',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Spend',
		field: 'spend',
		colId: 'spend',
		filter: 'agNumberColumnFilter',
		filterParams: {
			values: [],
			filterOptions: [
				'equals',
				'notEqual',
				'lessThan',
				'lessThanOrEqual',
				'greaterThan',
				'greaterThanOrEqual',
			],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.spend !== 0
				? spendFormatter(params.data?.spend, true)
				: '-';
		},
	},

	{
		headerName: 'Workshop ID',
		field: 'workshop_key',
		colId: 'workshop_key',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'WorkShop Name',
		field: 'workshop_Name',
		colId: 'workshop_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier ID',
		field: 'supplier_Id',
		colId: 'supplier_Id',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'SUPPLIER NAME',
		field: 'normalized_Vendor',
		colId: 'normalized_Vendor',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier Category Group',
		field: 'supplier_Description',
		colId: 'supplier_Description',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
		minWidth: 144,
	},
	{
		headerName: 'Supplier Details',
		field: 'supplier_Details',
		colId: 'supplier_Details',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		suppressPaste: true,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Final Spend Owner Name',
		field: 'final_Spend_Owner_Name',
		colId: 'final_Spend_Owner_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 1,
			cols: 40,
		},
		headerClass: 'header-ag-blue',
	},
	{
		headerName: 'is this vendor business critical',
		field: 'is_this_vendor_business_critical',
		colId: 'is_this_vendor_business_critical',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		minWidth: 170,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: YES_NO,
		},
		valueSetter: params => {
			if (YES_NO.includes(params.newValue)) {
				const newVal = params.newValue;
				const valueChanged =
					params.data.is_this_vendor_business_critical !== newVal;
				if (valueChanged) {
					params.data.is_this_vendor_business_critical = newVal;
				}
				return valueChanged;
			}
			return false;
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
	{
		headerName: 'Recommended Action',
		field: 'recommended_Action',
		colId: 'recommended_Action',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agRichSelectCellEditor',
		singleClickEdit: true,
		cellEditorParams: {
			values: MICRO_TAIL_ACTION,
		},
		minWidth: 150,
		valueSetter: params => {
			if (MICRO_TAIL_ACTION.includes(params.newValue)) {
				const newVal = params.newValue;
				const valueChanged = params.data?.final_Supplier_Action !== newVal;
				if (valueChanged) {
					params.data.final_Supplier_Action = newVal;
				}
				return valueChanged;
			}
			return false;
		},
		headerClass: 'header-ag-blue',
		cellClass: 'dropdown-cell',
	},
	{
		headerName: 'Business Justification',
		field: 'business_justification',
		colId: 'business_justification',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		editable: true,
		cellStyle: handleEmptyCellColor,
		cellEditor: 'agLargeTextCellEditor',
		cellEditorPopup: true,
		cellEditorParams: {
			rows: 3,
			cols: 40,
		},
		minWidth: 130,
		headerClass: 'header-ag-blue',
	},
];

export const MICRO_LAUNCH_GRAPHQL_DATA = {
	columnDefs: MICRO_LAUNCH_COLUMN_HEADERS,
	cteExist: false,
	primaryTable: '[sxr].[SPEND_CONTROLLER] a',
	rowGroups: [
		{ id: '1', displayName: 'iD', field: 'iD', selector: 'a', concat: true },
		{
			id: '2',
			displayName: 'spend_Owner',
			field: 'spend_Owner',
			selector: 'a',
		},
		{
			id: '3',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'a',
		},
		{
			id: '4',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'a',
		},
		{
			id: '5',
			displayName: 'is_this_vendor_business_critical',
			field: 'is_this_vendor_business_critical',
			selector: 'a',
		},
		{
			id: '6',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'a',
		},
		{
			id: '7',
			displayName: 'business_justification',
			field: 'business_justification',
			selector: 'a',
		},
		{
			id: '8',
			displayName: 'recommended_Action',
			field: 'recommended_Action',
			selector: 'a',
		},
		{
			id: '9',
			displayName: 'savings_opportunity',
			field: 'savings_opportunity',
			selector: 'a',
		},
		{
			id: '10',
			displayName: 'workshop_key',
			field: 'workshop_key',
			selector: 'a',
		},
		{
			id: '11',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'a',
		},
		{
			id: '12',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'a',
		},
		{
			id: '13',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'a',
		},
	],
	caseModel: [],
	valueCols: [
		{
			id: '1',
			aggFunc: 'sum',
			displayName: 'spend',
			field: 'spend',
			selector: 'a',
			alias: 'spend',
		},
	],
	joinModel: [],
	filterModel: [],
	havingModel: [],
	groupCols: [
		{
			id: '1',
			displayName: 'spend_Owner',
			field: 'spend_Owner',
			selector: 'a',
		},
		{
			id: '2',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'a',
		},
		{
			id: '3',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'a',
		},
		{
			id: '4',
			displayName: 'is_this_vendor_business_critical',
			field: 'is_this_vendor_business_critical',
			selector: 'a',
		},
		{
			id: '5',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'a',
		},
		{
			id: '6',
			displayName: 'business_justification',
			field: 'business_justification',
			selector: 'a',
		},
		{
			id: '7',
			displayName: 'recommended_Action',
			field: 'recommended_Action',
			selector: 'a',
		},
		{
			id: '8',
			displayName: 'savings_opportunity',
			field: 'savings_opportunity',
			selector: 'a',
		},
		{
			id: '9',
			displayName: 'workshop_key',
			field: 'workshop_key',
			selector: 'a',
		},
		{
			id: '10',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'a',
		},
		{
			id: '11',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'a',
		},
		{
			id: '12',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'a',
		},
	],
};
export const BREAKDOWN_BY_FILTERS = [
	{ label: 'BUSINESS UNIT', value: 0 },
	{ label: 'ENTITY', value: 1 },
	{ label: 'SPEND OWNERS', value: 2 },
	{ label: 'FINAL CATEGORY', value: 3 },
	{ label: 'SUPPLIER NAME', value: 4 },
];
export const MICRO_MACRO_FILTERS = [
	{ label: 'MICRO', value: 'MICRO' },
	{ label: 'MACRO', value: 'MACRO' },
];
export const SPEND_CONTROLLER_BASELINE_FILTERS_STACK_1 = [
	{
		sectionFormLabel: 'BUSINESS UNIT',
		key: 0,
		name: 'business_Unit',
		label: 'Select',
		disabled: false,
		isLoading: false,
		options: ['Option 1', 'Option 2', 'Option 3'], // Example options
		selected: [],
		onChange: value => console.log(value),
	},
	{
		sectionFormLabel: 'ENTITY',
		key: 1,
		name: 'entity',
		label: 'Select',
		disabled: false,
		isLoading: false,
		options: ['Option A', 'Option B', 'Option C'], // Example options
		selected: [],
		onChange: value => console.log(value),
	},
	{
		sectionFormLabel: 'SPEND OWNER',
		key: 2,
		name: 'spend_Owner',
		label: 'Select',
		disabled: false,
		isLoading: false,
		options: ['Family 1', 'Family 2', 'Family 3'], // Example options
		selected: [],
		onChange: value => console.log(value),
	},
];

export const SPEND_CONTROLLER_BASELINE_FILTERS_STACK_2 = [
	{
		sectionFormLabel: 'FINAL CATEGORY',
		key: 3,
		name: 'final_Category',
		label: 'Select',
		disabled: false,
		isLoading: false,
		options: ['Detail 1', 'Detail 2', 'Detail 3'], // Example options
		selected: [],
		onChange: value => console.log(value),
	},
	{
		sectionFormLabel: 'SUPPLIER NAME',
		key: 4,
		name: 'normalized_Vendor',
		label: 'Select',
		disabled: false,
		isLoading: false,
		options: ['Supplier 1', 'Supplier 2', 'Supplier 3'], // Example options
		selected: [],
		onChange: value => console.log(value),
	},
];
export function extractPathDetails(path) {
	// Split the path by the dot character
	const parts = path.split('.');

	// Extract the first part (stack_1[0])
	const objectPart = parts[0];

	// Extract the second part (selected)
	const valueAfterDot = parts[1];

	// Use a regular expression to extract the object name and number
	const regex = /(\w+)\[(\d+)\]/;
	const match = objectPart.match(regex);

	if (match) {
		const objectName = match[1]; // stack_1
		const number = match[2]; // 0

		return {
			objectName: objectName,
			number: number,
			valueAfterDot: valueAfterDot,
		};
	} else {
		return null;
	}
}
export function extractSelectedArrays(formStructure) {
	const result = {};

	formStructure.stack_1.forEach(item => {
		result[item.name.replace('_', '')] = item.selected;
	});
	formStructure.stack_2.forEach(item => {
		result[item.name.replace('_', '')] = item.selected;
	});

	return result;
}

export function formatPreWorkShopKpiData(obj) {
	let keyValues = Object.entries(obj);
	keyValues.splice(1, 0, [
		['Response Received'],
		obj.responses_Received + '/' + obj.total_Supplier_Records,
	]);
	let newObj = Object.fromEntries(keyValues);
	delete newObj.responses_Received;
	delete newObj.total_Supplier_Records;
	return newObj;
}

export function convertToPercentage(decimal, decimalPlaces = 2) {
	if (typeof decimal !== 'number' || typeof decimalPlaces !== 'number') {
		throw new Error('Invalid input: decimal and decimalPlaces must be numbers');
	}
	const percentage = decimal.toFixed(decimalPlaces);
	return `${percentage}%`;
}

export const filterSelectedOptions = options => {
	let filteredOptions = {};
	for (let key in options) {
		if (options[key].selectedOption && options[key].selectedOption.length > 0) {
			filteredOptions[key] = options[key];
		}
	}
	return filteredOptions;
};

export const transformFilterOptions = options => {
	let transformedOptions = {};
	for (let key in options) {
		if (options[key].selectedOption && options[key].selectedOption.length > 0) {
			transformedOptions[key] = {
				values: options[key].selectedOption,
				filterType: 'set',
			};
		}
	}
	return transformedOptions;
};

export const convertToFilterFormat = filtersArray => {
	return filtersArray.reduce((acc, filter) => {
		if (filter.selected.length > 0) {
			acc[filter.name] = {
				values: filter.selected,
				filterType: 'set',
				filter: 'agSetColumnFilter',
			};
		}
		return acc;
	}, {});
};

export const PREWORKSHOP_BASELINE_KPI_DATA = {
	data: PREWORKSHOP_BASELINE_SUMMARY_DATA,
	columns: PREWORKSHOP_BASELINE_SUMMARY_COLUMNS,
	rows: PREWORKSHOP_BASELINE_SUMMARY_ROWS,
	title: PREWORKSHOP_BASELINE_SUMMARY_TITLE,
};

export const PREWORKSHOP_VENDOR_KPI_DATA = {
	data: PREWORKSHOP_VENDOR_DATA,
	columns: PREWORKSHOP_VENDOR_COLUMNS,
	rows: PREWORKSHOP_VENDOR_ROWS,
	title: PREWORKSHOP_VENDOR_TITLE,
};
export const MICROTAIL_BASELINE_KPI_DATA = {
	data: MICROTAIL_BASELINE_SUMMARY_DATA,
	columns: MICROTAIL_BASELINE_SUMMARY_COLUMNS,
	rows: MICROTAIL_BASELINE_SUMMARY_ROWS,
	title: MICROTAIL_BASELINE_SUMMARY_TITLE,
};
export const MICROTAIL_VENDOR_KPI_DATA = {
	data: MICROTAIL_VENDOR_DATA,
	columns: MICRO_TAIL_COLUMNS,
	rows: MICRO_TAIL_ROWS,
	title: MICROTAIL_VENDOR_TITLE,
};
export const MICROTAIL_PRELIMINARY_SAVINGS_KPI_DATA = {
	data: MICRO_TAIL_SUMMARY_DATA,
	columns: MICRO_TAIL_COLUMNS,
	rows: MICRO_TAIL_ROWS,
	// Fcolor: colors.green300,
	title: MICRO_TAIL_SUMMARY_TITLE,
};

export const combinePreWorkshopBaselineKpiData = (data, summaryData) => {
	return summaryData.map(item => {
		switch (item.cardTitle) {
			case 'Total Baseline Spend':
				return {
					...item,
					value: spendFormatter(data.total_Baseline_Spend),
					isCurrency: true,
				};
			case 'Baseline Spend Actioned':
				return {
					...item,
					value: `${spendFormatter(
						data.baseline_Spend_Actioned
					)}/${convertToPercentage(
						data.percentage_Baseline_Spend_Actioned,
						1
					)}`,
					isCurrency: false,
				};
			case 'Unclaimed Baseline Spend':
				return {
					...item,
					value: `${spendFormatter(
						data.unclaimed_Baseline_Spend
					)}/${convertToPercentage(
						data.percentage_Unclaimed_Baseline_Spend,
						1
					)}`,
					isCurrency: false,
				};
			case 'Baseline Actioned':
				return {
					...item,
					value: `${spendFormatter(data.baseline_Spend_Actioned)}`,
					isCurrency: false,
				};
			case 'Eliminate':
				return {
					...item,
					value: `${spendFormatter(data.eliminate)}`,
					isCurrency: false,
				};
			case 'Reduce Demand':
				return {
					...item,
					value: `${spendFormatter(data.reduce_Demand)}`,
					isCurrency: false,
				};
			case 'Consolidate':
				return {
					...item,
					value: `${spendFormatter(data.consolidate)}`,
					isCurrency: false,
				};
			case 'Continue to use':
				return {
					...item,
					value: `${spendFormatter(data.continue_To_Use)}`,
					isCurrency: false,
				};
			case 'Responses Received':
				return {
					...item,
					value: `${data.preworkshop_Responses_Received}/${
						data.preworkshop_Total_Supplier_Records
					}`,
				};
			case 'Responses Received (%)':
				return {
					...item,
					value: `${convertToPercentage(
						data.preworkshop_Responses_Received_Percentage,
						1
					)}`,
				};
			default:
				return item;
		}
	});
};

export const PREWORKSHOP_PRELIMINARY_SAVINGS_KPI_DATA = {
	data: PRE_WORKSHOP_SUMMARY_DATA,
	columns: PRE_WORKSHOP_SUMMARY_COLUMNS,
	rows: PRE_WORKSHOP_SUMMARY_ROWS,
	// Fcolor: colors.green300,
	title: PRE_WORKSHOP_SUMMARY_TITLE,
};
export const WORKSHOP_KPI_DATA = {
	data: WORKSHOP_SUMMARY_DATA,
	columns: WORKSHOP_BASELINE_SUMMARY_COLUMNS,
	rows: WORKSHOP_BASELINE_SUMMARY_ROWS,
	// Fcolor: colors.green300,
	title: WORKSHOP_BASELINE_SUMMARY_TITLE,
};
export const SAVINGS_SIGNS_OFF_KPI_DATA = {
	data: SAVINGS_SIGNS_OFF_SUMMARY_DATA,
	columns: SAVINGS_SIGNS_OFFS_SUMMARY_COLUMNS,
	rows: SAVINGS_SIGNS_OFFS_SUMMARY_ROWS,
	title: SAVINGS_SIGNS_OFFS_SUMMARY_TITLE,
};
export const LOST_SAVINGS_KPI_DATA = {
	data: LOST_SAVINGS_SIGNS_OFF_SUMMARY_DATA,
	columns: LOST_SAVINGS_SIGNS_OFFS_SUMMARY_COLUMNS,
	rows: LOST_SAVINGS_SIGNS_OFFS_SUMMARY_ROWS,
	title: LOST_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE,
	Fcolor: '#FFB9B9',
};
export const combinePreWorkshopData = (response, existingData) => {
	const data = response.data;
	return existingData.map(item => {
		if (item.cardTitle === 'Preliminary Savings') {
			return {
				...item,
				value: spendFormatter(data.preliminary_Savings),
			};
		}
		if (item.cardTitle === 'Preliminary Savings %') {
			return {
				...item,
				value: convertToPercentage(data.preliminary_Savings_Percentage, 1),
			};
		}
		return item;
	});
};
export const combineMicroTailVendorData = (response, existingData) => {
	const data = response.data;
	return existingData.map(item => {
		switch (item.cardTitle) {
			case 'Eliminate':
				return {
					...item,
					value: `${spendFormatter(data.eliminate)}`,
					isCurrency: false,
				};
			case 'Continue to use':
				return {
					...item,
					value: `${spendFormatter(data.continue_To_Use)}`,
					isCurrency: false,
				};
			default:
				return item;
		}
	});
};

const keyWorkShopMapping = {
	Eliminate: 'eliminate',
	'Reduce Demand': 'reduce_Demand',
	Consolidate: 'consolidate',
	'Total Savings': 'total_Savings',
	'Continue to use': 'continue_To_Use',
	Unclaimed: 'unClaimed',
};
export function combineDataWorkShopKpiData(apiData, cardData) {
	return cardData.map(card => {
		const apiKey = keyWorkShopMapping[card.cardTitle];
		const apiValue = apiData.data[apiKey];
		return {
			...card,
			value: spendFormatter(apiValue), // Assuming the values are in millions
			isCurrency: true,
		};
	});
}

export const keyMapping = {
	'Final Signed-off Savings': 'final_Signed_Off_Savings',
	'Final Signed-off Saving %': 'final_Signed_Off_Savings_Percentage',
	'Savings Pending Sign-off': 'savings_Pending_SignOff',
	'Records Pending Sign-off': 'records_Pending_Sign_Off',
	'Total Lost Savings': 'total_Lost_Savings',
	'Total Lost Records': 'total_Lost_Records',
};

export function updateSavingsData(apiData, cardData, keyMap) {
	return cardData.map(card => {
		const apiKey = keyMap[card.cardTitle];
		const apiValue = apiData.data[apiKey];
		return {
			...card,
			value:
				apiKey === 'final_Signed_Off_Savings_Percentage'
					? convertToPercentage(apiValue, 1)
					: apiKey === 'records_Pending_Sign_Off' ||
					  apiKey === 'total_Lost_Records'
						? apiValue
						: spendFormatter(apiValue), // Assuming the values are in millions
			isCurrency: true,
		};
	});
}

export const WATERFALL_DATA = [
	{
		name: 'Identified',
		data: [
			{ y: 7233926.58, color: colors.green100, customTooltip: true },
			{ y: 5125406.78, color: colors.green100, customTooltip: true },
			{ y: 2640313.56, color: colors.green100, customTooltip: true },
			{ y: 0, color: colors.grey200 },
			{ isIntermediateSum: true, color: colors.blue700, border: 'none' },
			{ y: 0, color: colors.blue400 },
			{ isSum: true, color: 'lightBlue' },
		],
	},
	{
		name: 'Confirmed',
		data: [
			{ y: 0.0, color: colors.green500, customTooltip: true },
			{ y: 0.0, color: colors.green500, customTooltip: true },
			{ y: 0.0, color: colors.green500, customTooltip: true },
			{ y: 10712248.34, color: colors.grey200 },
			{ isIntermediateSum: true, color: colors.blue700, border: 'none' },
			{ y: 25711895.26, color: colors.blue400 },
			{ isSum: true, color: 'lightBlue' },
		],
	},
];

export const displayOrder = [
	{ key: 'initial_Baseline_Spend', label: 'Initial Baseline Spend' },
	{ key: 'unactioned', label: 'Unactioned Baseline' },
	{ key: 'actioned', label: 'Actioned Baseline' },
	{ key: 'continue_To_Use', label: 'Continue to Use' },
	{ key: 'consolidate', label: 'Consolidate' },
	{ key: 'reduce_Demand', label: 'Reduce Demand' },
	{ key: 'eliminate', label: 'Eliminate' },
];

export const combineWaterFallData = response => {
	return [
		{
			name: 'Identified',
			data: [
				{
					y: response.eliminate_Identified,
					color: colors.green100,
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'middle',
						formatter: function() {
							return this.y > 0 ? spendFormatter(this.y) : null;
						},
					},
					tooltip: true,
				},
				{
					y: response.reduce_Demand_Identified,
					color: colors.green100,
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'middle',
						formatter: function() {
							return this.y > 0 ? spendFormatter(this.y) : null;
						},
					},
					tooltip: true,
				},
				{
					y: response.consolidate_Identified,
					color: colors.green100,
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'middle',
						formatter: function() {
							return response.consolidate_Identified > 0
								? spendFormatter(response.consolidate_Identified)
								: null;
						},
					},
					tooltip: true,
				},
				{
					y: 0,
					color: colors.grey200,
					tooltip: {
						enabled: false,
						shared: true,
						distance: 56,
						useHTML: true,
						backgroundColor: 'rgba(255,255,255, 0.9)',
						borderWidth: 0,
						outside: true,
						borderRadius: 2,
					},
				},
				{
					isIntermediateSum: true,
					color: colors.blue700,
					borderColor: colors.blue700,
					borderWidth: 0.2,
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'top',
						y: -20,
						formatter: function() {
							if (isUndefined(response.actioned)) {
								return '$0';
							} else {
								return spendFormatter(response.actioned, true);
							}
						},
					},
				},
				{
					y: response.unactioned,
					color: colors.blue400,
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'top',
						y: -20,
						formatter: function() {
							if (isUndefined(response.unactioned)) {
								return '$0';
							} else {
								return spendFormatter(response.unactioned, true);
							}
						},
					},
				},
				{
					isSum: true,
					color: 'lightBlue',
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'top',
						y: -20,
						formatter: function() {
							if (isUndefined(response.initial_Baseline_Spend)) {
								return '$0';
							} else {
								return spendFormatter(response.initial_Baseline_Spend, true);
							}
						},
					},
				},
			],
		},
		{
			name: 'Confirmed',
			data: [
				{
					y: response.eliminate_Confirmed,
					color: colors.green500,
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'middle',
						formatter: function() {
							return this.y > 0 ? spendFormatter(this.y) : null;
						},
					},
					tooltip: true,
				},
				{
					y: response.reduce_Demand_Confirmed,
					color: colors.green500,
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'middle',
						formatter: function() {
							return this.y > 0 ? spendFormatter(this.y) : null;
						},
					},
					tooltip: true,
				},
				{
					y: response.consolidate_Confirmed,
					color: colors.green500,
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'middle',
						formatter: function() {
							return this.y > 0 ? spendFormatter(this.y) : null;
						},
					},
					tooltip: true,
				},
				{
					y: response.continue_to_use,
					color: colors.grey200,
					dataLabels: {
						enabled: true,
						align: 'center',
						verticalAlign: 'top',
						y: -20,
						formatter: function() {
							if (isUndefined(response.continue_to_use)) {
								return '$0';
							} else {
								return spendFormatter(response.continue_to_use, true);
							}
						}, // Always shows label at top
					},
				},
				{
					isIntermediateSum: true,
					color: colors.blue700,
					borderWidth: -1,
					borderColor: colors.blue700,
				},
				{
					y: 0,
					color: colors.blue400,
				},
				{
					isSum: true,
					color: 'lightBlue',
					borderWidth: -1,
					borderColor: 'lightBlue',
				},
			],
		},
	];
	// }
};

export function combinePieData(initialData, arrayData) {
	const mappings = {
		eliminate: 'Eliminate',
		reduce_Demand: 'Reduce Demand',
		consolidate: 'Consolidate',
	};

	return arrayData.map(item => {
		const key = Object.keys(mappings).find(key => mappings[key] === item.name);
		if (key && initialData[key] !== undefined) {
			return {
				...item,
				y: initialData[key],
			};
		}
		return item;
	});
}

export const getSavingData = (initialSpend, currentSaving) => {};

export function getSubtitle(data) {
	return `
	<span style="margin-left:2px; text-align:center; font-size:28px;font-weight:bold;">${
		data[0]
	} </span>
		<br>
		<span style="display: block; text-align: center; color: green; font-size:15px;font-weight:bold">
			<b> (${data[1].toFixed(1)})%</b> 
		</span>`;
}
export function getCustomTitle(data) {
	return `
	<div style="display: inline-block; font-size: 27px; margin-top: 5px; font-weight:bold">
	${data[0]}
		<div style="display: inline-block; font-size: 15px; color: green; font-weight:bold">
			(${data[1].toFixed(1)})%
		</div>
	</div>
	
    `;
}
export const PIE_DATA = [
	{
		name: 'Reduce Demand',
		y: 619,
		color: colors.green100, // 2020 color
		dataLabels: {
			enabled: true,
			distance: 5,
			formatter: function() {
				if (isUndefined(this.y)) {
					return 'Reduce Demand <br/> $0';
				} else {
					return (
						'Reduce Demand <br/>' +
						'<b>' +
						` ${spendFormatter(this.y, true)}` +
						'</b>'
					);
				}
			},
			style: {
				fontSize: '14px',
				color: 'black',
				fontWeight: 'normal',
			},
		},
	},
	{
		name: 'Consolidate',
		y: 586,
		color: colors.green300, // 2022 color
		dataLabels: {
			enabled: true,
			distance: 5,
			formatter: function() {
				if (isUndefined(this.y)) {
					return 'Consolidate <br/>$0';
				} else {
					return (
						'Consolidate<br/> ' +
						'<b>' +
						` ${spendFormatter(this.y, true)}` +
						'</b>'
					);
				}
			},
			style: {
				fontSize: '14px',
				color: 'black',
				fontWeight: 'normal',
			},
		},
	},
	{
		name: 'Eliminate',
		y: 647,
		color: colors.green500, // 2021 color

		dataLabels: {
			enabled: true,
			distance: 5,
			formatter: function() {
				if (isUndefined(this.y)) {
					return 'Eliminate <br/>$0';
				} else {
					return (
						' Eliminate <br/>' +
						'<b>' +
						` ${spendFormatter(this.y, true)}` +
						'</b>'
					);
				}
			},
			style: {
				fontSize: '14px',
				color: 'black',
				fontWeight: 'normal',
			},
		},
	},
];
export const PIE_OPT = {
	chart: {
		// spacingTop: 22,
		backgroundColor: 'rgba(0,0,0,0)',
		style: {
			fontFamily: 'Roboto',
		},
		spacing: [0, 0, 0, 0],
		marginTop: 40,
		// spacingBottom: 20,
		height: 400,
	},

	title: {
		text: '',
		useHTML: true,
		align: 'left',
	},
	legend: {
		enabled: true,
		itemStyle: {
			textOverflow: 'ellipsis',
			fontSize: '13px',
			color: colors.grey500,
			fontWeight: 'normal',
		},
	},
	credits: {
		enabled: false,
	},
	exporting: {
		enabled: false,
	},
	tooltip: {
		enabled: false,
	},
	plotOptions: {
		series: {
			animation: true,
			stacking: 'normal',
			pointPadding: 0,
			groupPadding: 0,
		},
	},
	series: [
		{
			type: 'pie',
			name: 'Total',
			data: PIE_DATA,
			showInLegend: true,
			size: 250,
			innerSize: '75%',
		},
	],
};
export const VENDOR_COUNT = {
	initial_Baseline_Spend: 0,
	unactioned: 0,
	actioned: 0,
	eliminate: 0,
	reduce_Demand: 0,
	continue_To_Use: 0,
	consolidate: 0,
};
export const PROGRAMS_SAVINGS_DASHBOARD = [
	{
		headerName: 'Spend Owner',
		field: 'spend_Owner',
		colId: 'spend_Owner',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Total Incremental Savings',
		field: 'total_Incremental_Savings',
		colId: 'total_Incremental_Savings',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.total_Incremental_Savings !== 0
				? spendFormatter(params.data?.total_Incremental_Savings, true)
				: '-';
		},
	},
	{
		headerName: 'Macro Savings',
		field: 'macro_Savings',
		colId: 'macro_Savings',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.macro_Savings !== 0
				? spendFormatter(params.data?.macro_Savings, true)
				: '-';
		},
	},
	{
		headerName: 'Micro Savings',
		field: 'micro_Savings',
		colId: 'micro_Savings',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.micro_Savings !== 0
				? spendFormatter(params.data?.micro_Savings, true)
				: '-';
		},
	},
];

export const PROGRAMS_SAVINGS_MICRO_MACRO_DASHBOARD = [
	{
		headerName: 'Function /  Phase',
		field: 'function',
		colId: 'function',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Savings',
		field: 'savings',
		colId: 'savings',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.savings !== 0
				? spendFormatter(params.data?.savings, true)
				: '-';
		},
	},
];

export function convertMicroMacroData(data) {
	return Object.keys(data).map(key => {
		return {
			function: key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
			savings: data[key],
		};
	});
}
export const MICRO_MACRO_TABLE_STYLES = {
	flex: 0.3,
	display: 'flex',
	justifyContent: 'center',
	marginTop: '4%',
};

export const VENDOR_ELIMINATION_REPORT = [
	{
		headerName: 'Business Unit',
		field: 'business_Unit',
		colId: 'business_Unit',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Entity Description',
		field: 'entity_Description',
		colId: 'entity_Description',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Department',
		field: 'department',
		colId: 'department',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Final Spend Owner Name',
		field: 'final_Spend_Owner_Name',
		colId: 'final_Spend_Owner_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Normalized Vendor',
		field: 'normalized_Vendor',
		colId: 'normalized_Vendor',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Final Category',
		field: 'final_Category',
		colId: 'final_Category',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Spend',
		field: 'spend',
		colId: 'spend',
		suppressMenu: true,
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.spend !== 0
				? spendFormatter(params.data?.spend, true)
				: '-';
		},
	},
	{
		headerName: 'Final Supplier Action',
		field: 'final_Supplier_Action',
		colId: 'final_Supplier_Action',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		minWidth: 150,
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Confirmed Reduction',
		field: 'new_Reduction',
		colId: 'new_Reduction',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.new_Reduction + '% ';
		},
	},
	{
		headerName: 'Final Savings',
		field: 'final_Savings',
		colId: 'final_Savings',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.final_Savings !== 0
				? spendFormatter(params.data?.final_Savings, true)
				: '-';
		},
	},
];
export const GL_ACCOUNT_MASTER_HEADERS = [
	{
		headerName: 'Workshop ID',
		field: 'workshop_id',
		colId: 'workshop_id',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'WorkShop Name',
		field: 'workshop_Name',
		colId: 'workshop_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier ID',
		field: 'supplier_Id',
		colId: 'supplier_Id',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier Description',
		field: 'supplier_Description',
		colId: 'supplier_Description',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Supplier Details',
		field: 'supplier_Details',
		colId: 'supplier_Details',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'iD',
		field: 'iD',
		colId: 'iD',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
		hide: true,
	},
	{
		headerName: 'Business Unit',
		field: 'business_Unit',
		colId: 'business_Unit',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'GL Account String',
		field: 'gl_Account_Number',
		colId: 'gl_Account_Number',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'GL Account Number',
		field: 'gl_Account_String',
		colId: 'gl_Account_String',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Entity Description',
		field: 'entity_Description',
		colId: 'entity_Description',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Account Description',
		field: 'account_Description',
		colId: 'account_Description',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Department',
		field: 'department',
		colId: 'department',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Spend Department',
		field: 'spend_Department',
		colId: 'spend_Department',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Final Spend Owner Name',
		field: 'final_Spend_Owner_Name',
		colId: 'final_Spend_Owner_Name',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Normalized Vendor',
		field: 'normalized_Vendor',
		colId: 'normalized_Vendor',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Final Category',
		field: 'final_Category',
		colId: 'final_Category',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Record Action Data',
		field: 'final_Supplier_Action',
		colId: 'final_Supplier_Action',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
	{
		headerName: 'Confirmed Reduction',
		field: 'new_Reduction',
		colId: 'new_Reduction',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.new_Reduction + '% ';
		},
	},
	{
		headerName: 'Final Savings',
		field: 'final_Savings',
		colId: 'final_Savings',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
		valueGetter: params => {
			return params.data?.final_Savings !== 0
				? spendFormatter(params.data.final_Savings, true)
				: '-';
		},
	},
	{
		headerName: 'Is Lost Savings?',
		field: 'is_Loss_Savings',
		colId: 'is_Loss_Savings',
		filter: 'agSetColumnFilter',
		filterParams: {
			values: [],
		},
		headerClass: 'header-ag-green',
	},
];

export const GL_ACCOUNT_MASTER_DATA = {
	columnDefs: GL_ACCOUNT_MASTER_HEADERS,
	cteModel: [],
	primaryTable: '[sxr].[SPEND_CONTROLLER] a',
	rowGroups: [
		{ id: '1', displayName: 'iD', field: 'iD', selector: 'a', concat: true },
		{
			id: '2',
			displayName: 'business_Unit',
			field: 'business_Unit',
			selector: 'a',
		},
		{
			id: '3',
			displayName: 'gl_Account_String',
			field: 'gl_Account_String',
			selector: 'a',
		},
		{
			id: '4',
			displayName: 'gl_Account_Number',
			field: 'gl_Account_Number',
			selector: 'a',
		},
		{
			id: '5',
			displayName: 'entity_Description',
			field: 'entity_Description',
			selector: 'a',
		},
		{
			id: '6',
			displayName: 'account_Description',
			field: 'account_Description',
			selector: 'a',
		},
		{ id: '7', displayName: 'department', field: 'department', selector: 'a' },
		{
			id: '8',
			displayName: 'spend_Department',
			field: 'spend_Department',
			selector: 'a',
		},
		{
			id: '9',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'a',
		},
		{
			id: '10',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'a',
		},
		{
			id: '11',
			displayName: 'final_Category',
			field: 'final_Category',
			selector: 'a',
		},
		{
			id: '12',
			displayName: 'final_Supplier_Action',
			field: 'final_Supplier_Action',
			selector: 'a',
		},
		{
			id: '13',
			displayName: 'new_Reduction',
			field: 'new_Reduction',
			selector: 'a',
		},
		{
			id: '14',
			displayName: 'final_Savings',
			field: 'final_Savings',
			selector: 'a',
		},
		{
			id: '15',
			displayName: 'is_Loss_Savings',
			field: 'is_Loss_Savings',
			selector: 'a',
		},
		{
			id: '16',
			displayName: 'workshop_id',
			field: 'workshop_id',
			selector: 'a',
		},
		{
			id: '17',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'a',
		},
		{
			id: '18',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'a',
		},
		{
			id: '19',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'a',
		},
		{
			id: '20',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'a',
		},
	],
	caseModel: [],
	valueCols: [
		{
			id: '1',
			aggFunc: 'sum',
			displayName: 'spend',
			field: 'spend',
			selector: 'a',
			alias: 'spend',
		},
	],
	joinModel: [],
	filterModel: [
		{
			final_Supplier_Action: {
				values: ['Eliminate', 'Reduce Demand'],
				filterType: 'set',
			},
		},
	],
	havingModel: [],
	groupCols: [
		{
			id: '1',
			displayName: 'business_Unit',
			field: 'business_Unit',
			selector: 'a',
		},
		{
			id: '2',
			displayName: 'gl_Account_String',
			field: 'gl_Account_String',
			selector: 'a',
		},
		{
			id: '3',
			displayName: 'gl_Account_Number',
			field: 'gl_Account_Number',
			selector: 'a',
		},
		{
			id: '4',
			displayName: 'entity_Description',
			field: 'entity_Description',
			selector: 'a',
		},
		{
			id: '5',
			displayName: 'account_Description',
			field: 'account_Description',
			selector: 'a',
		},
		{ id: '6', displayName: 'department', field: 'department', selector: 'a' },
		{
			id: '7',
			displayName: 'spend_Department',
			field: 'spend_Department',
			selector: 'a',
		},
		{
			id: '8',
			displayName: 'final_Spend_Owner_Name',
			field: 'final_Spend_Owner_Name',
			selector: 'a',
		},
		{
			id: '9',
			displayName: 'normalized_Vendor',
			field: 'normalized_Vendor',
			selector: 'a',
		},
		{
			id: '10',
			displayName: 'final_Category',
			field: 'final_Category',
			selector: 'a',
		},
		{
			id: '11',
			displayName: 'final_Supplier_Action',
			field: 'final_Supplier_Action',
			selector: 'a',
		},
		{
			id: '12',
			displayName: 'new_Reduction',
			field: 'new_Reduction',
			selector: 'a',
		},
		{
			id: '13',
			displayName: 'final_Savings',
			field: 'final_Savings',
			selector: 'a',
		},
		{
			id: '14',
			displayName: 'is_Loss_Savings',
			field: 'is_Loss_Savings',
			selector: 'a',
		},
		{
			id: '15',
			displayName: 'workshop_id',
			field: 'workshop_id',
			selector: 'a',
		},
		{
			id: '16',
			displayName: 'workshop_Name',
			field: 'workshop_Name',
			selector: 'a',
		},
		{
			id: '17',
			displayName: 'supplier_Id',
			field: 'supplier_Id',
			selector: 'a',
		},
		{
			id: '18',
			displayName: 'supplier_Details',
			field: 'supplier_Details',
			selector: 'a',
		},
		{
			id: '19',
			displayName: 'supplier_Description',
			field: 'supplier_Description',
			selector: 'a',
		},
	],
	cteExist: false,
	startRow: 0,
	endRow: 100,
	sorting: [],
};

export const convertNumberFiltersToString = filterModel => {
	const updatedFilterModel = Object.entries(filterModel).reduce(
		(acc, [key, filter]) => {
			if (filter.filterType === 'number') {
				acc[key] = {
					...filter,
					filter: filter.filter !== null ? String(filter.filter) : null,
					filterTo: filter.filterTo !== null ? String(filter.filterTo) : null,
				};
			} else {
				acc[key] = filter;
			}
			return acc;
		},
		{}
	);

	return updatedFilterModel;
};

export const colIdsToSum = [
	'spend',
	'total_Savings',
	'remaining_Spend_Pre',
	'remaining_Spend_Wor',
	'final_Savings',
];
export const savingsType = [
	{
		label: 'Identified Savings',
		value: 1,
	},
	{
		label: 'Confirmed Savings',
		value: 2,
	},

	{
		label: 'Total Savings',
		value: 3,
	},
];
